<template>
  <main id="admin-content">
    <b-container fluid class="login-form-container">
      <div class="full-page-wrap">
        <div class="justify-content-center">
          <div class="full-page-content error-page">
            <img class="logo" src="/static/img/logo.png" alt="Logo Proeduca"/>
            <div class="m-5">
              <div class="clearfix" style="color: #000">
                <h1>
                  {{ $t("errors.notautheticateTitle") }}
                </h1>
                <h2>
                  {{ $t("errors.notautheticate") }}
                </h2>
                <h4 class="pt-3">{{ $t("info.cantactAdmin") }}</h4>
              </div>
            </div>
            <div class="login-options">
            <a
              href="https://www.grupoproeduca.com"
              target="_blank"
              class="legal"
              >©{{ new Date().getFullYear() }} Grupo Proeduca. Todos los
              derechos reservados.</a
            >
            </div>
          </div>
        </div>
      </div>
    </b-container>
  </main>
</template>
<style lang="scss">
.full-page-content.error-page {
  max-width: none;
  width: 100%;
}
.login-options > a{
  font-size: .75rem;
  color: #2c2c2c;
}
.logo {
  max-width: 32.5rem;
}
</style>
<script>
import jwtMixin from '../../mixins/jwtMixin'

export default {
  name: 'Page401',
  mixins: [jwtMixin],
  created () {
    this.$i18n.locale = this.jwtLanguage()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/pages/Page401.vue